import { useState } from 'react';

// Portada 1:1 sin recorte (norma de Spotify): object-contain, sin máscaras ni overlays.
export function AlbumArt({ image, alt = '', className = '' }) {
  const [failed, setFailed] = useState(null); // guarda la URL que falló, así una nueva vuelve a intentar
  return (
    <div className={`aspect-square shrink-0 overflow-hidden rounded bg-lounge-chassis
                     shadow-sleeve ring-1 ring-lounge-line ${className}`}>
      {image && failed !== image ? (
        <img
          src={image}
          alt={alt}
          loading="lazy"
          draggable={false}
          onError={() => setFailed(image)}
          className="h-full w-full select-none object-contain"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center font-serif text-lounge-smoke">
          &#9834;
        </div>
      )}
    </div>
  );
}
